<template>
  <div class="action-label">
    <span>{{title}}</span>
    <el-button-group>
      <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
        <el-button @click="$emit('refresh')" size="mini" style="border: none">
          <i class="fas fa-redo-alt"></i>
        </el-button>
      </el-tooltip>

      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('event.buttons.addNew')"
        placement="top"
      >
        <el-button @click="$emit('new')" size="mini" style="border: none">
          <i class="fas fa-plus"></i>
        </el-button>
      </el-tooltip>
    </el-button-group>
  </div>
</template>

<script>
export default {
  name: "ActionableLabel",
  props: ["title"],
};
</script>

<style scoped>
.action-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ActionableLabel.vue